import { Swiper, SwiperSlide } from "swiper/react";
import { Line } from "../../components/Line";
import { Subtitle } from "../../components/Subtitle";
import { Text } from "../../components/Text";
import { SlideBulletNavigation } from "../../../../../components/blog/RelatedPosts/SlideBulletNavigation";
import { useState } from "react";
import { device, size } from "../../../../../constants";
import "swiper/css";
import { cn } from "../../../../../lib/utils";
import styled from "styled-components";
import { useWindowSize } from "../../../../../hooks/useWindowResize";
import { useTranslation } from "next-i18next";
import { SlideArrowNavigation } from "../../../../../components/blog/RelatedPosts/SlideArrowNavigation";

const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
	.arrows {
		display: none;

		button {
			svg path {
				

				:is([data-theme="dark"] &) {
					color: ${({ theme }) => theme.colors["background-02"]};
				}
			}
		}
		
		button:disabled {
			background-color: transparent;
			border-color: ${({ theme }) => theme.colors["neutral-03"]};

			svg path {
				color: ${({ theme }) => theme.colors["neutral-03"]};

				:is([data-theme="dark"] &) {
					color: ${({ theme }) => theme.colors["neutral-03"]};
				}
			}
		}
	}
	
	.bullets {
		.bullet {
			background-color: #398BE3;

			:is([data-theme="dark"] &) {
				background-color: #398BE3;
			}
		}
	}

  @media ${device.laptop} {
		justify-content: space-between;
    align-items: flex-start;
		
		.bullets {
			.bullet {
				background-color: #FFF;

				:is([data-theme="dark"] &) {
					background-color: #FFF;
				}
			}
		}

    .arrows {
      display: block;
			margin-left: auto;
    }
  }
`;

const SwiperWrapper = styled.div`
  .bullets-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bullet {
    background-color: #fff;
    opacity: 0.5;
  }
  
  .bullet-active {
    opacity: 1;
  }

  :is([data-theme="dark"] &) {
    .bullet {
      background-color: #fff;
    }
  }

	.swiper-slide:last-child > div {
		border-right: none;
	}
`;

function SolutionCard({ solution }) {
	return (
		<div
			className={cn(
				"rounded-lg bg-neutral-06 shadow-solutions",
				[
					"laptop:w-[400px] laptop:h-[614px] laptop:p-6 laptop:mx-0 laptop:mr-auto",
				],
				["p-4 h-[568px] w-[342px] mx-auto"],
			)}
		>
			<img
				className="laptop:w-[352px] laptop:h-[210px] w-full h-[180px]"
				src={solution.image}
				alt=""
			/>
			<h3 className="text-white font-semibold text-xl leading-[32px] laptop:text-2xl laptop:mt-6 laptop:mb-3 mt-4 mb-2">
				{solution.title}
			</h3>
			<p className="text-neutral-03 laptop:text-xl laptop:leading-8 text-lg leading-[30px]">
				{solution.description}
			</p>
		</div>
	);
}

export default function SolutionSection() {
	const { width } = useWindowSize();
	const { t } = useTranslation();
	const isLaptopL = width >= size.laptopL;
	const [activeBullet, setActiveBullet] = useState(0);

	const solutions = [
		{
			title: t("products.brinks.solution.steps.step1.title"),
			description: t("products.brinks.solution.steps.step1.description"),
			image: "/landings/assets/images/casos/assets/brinks/brinks-entendimento-completo.png",
		},

		{
			title: t("products.brinks.solution.steps.step2.title"),
			description: t("products.brinks.solution.steps.step2.description"),
			image: "/landings/assets/images/casos/assets/brinks/brinks-robos.png",
		},

		{
			title: t("products.brinks.solution.steps.step3.title"),
			description: t("products.brinks.solution.steps.step3.description"),
			image: "/landings/assets/images/casos/assets/brinks/brinks-organizacao-e-envio.png",
		},

		{
			title: t("products.brinks.solution.steps.step4.title"),
			description: t("products.brinks.solution.steps.step4.description"),
			image: "/landings/assets/images/casos/assets/brinks/brinks-controle-total.png",
		},
	];

	return (
		<section className="bg-background-02">
			<div className="container-blog">
				<div className="flex flex-col items-center mb-10 laptop:mb-14">
					<Line className="border-[#398BE3]" />

					<Subtitle>
						<h3>{t("products.brinks.solution.title")}</h3>
					</Subtitle>

					<Text className="max-w-[322px] laptop:max-w-[890px] mx-auto text-center">
						{t("products.brinks.solution.description")}
					</Text>
				</div>

				<SwiperWrapper>
					<Swiper
						slidesPerView={1}
						navigation={false}
						spaceBetween={isLaptopL ? 40 : 24}
						breakpoints={{
							[size.tablet]: {
								slidesPerView: 2,
							},
							[size.laptop]: {
								slidesPerView: 2,
							},
							[size.laptopL]: {
								slidesPerView: 3,
							},
						}}
						onSlideChange={(e) => {
							setActiveBullet(e.activeIndex);
						}}
					>
						{solutions.map((solution) => (
							<SwiperSlide key={solution.title}>
								<SolutionCard solution={solution} />
							</SwiperSlide>
						))}

						<NavigationContainer className="mt-6">
							<div className="bullets">
								<SlideBulletNavigation activeBullet={activeBullet} />
							</div>
							<div className="arrows">
								<SlideArrowNavigation />
							</div>
						</NavigationContainer>
					</Swiper>
				</SwiperWrapper>
			</div>
		</section>
	);
}
